

 


 //v2
 import Base64  from 'base-64';
 export function wsmOpenApp(path,content){
  if(content){
    let contents=Base64.encode(content).replace(/\+\//g,"-*")
    return `mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1&content=${contents}`
  }
 return `mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1`
} 

export function appUrlAndroid(path, content) {
  if (content) {
    let contents = Base64.encode(content).replace(/\+\//g, "-*")
    return encodeURIComponent(`mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1&content=${contents}`)
  }
  return encodeURIComponent(`mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1`)
}





export function appUrlIOS(path, content) {
  if (content) {
    let contents = Base64.encode(content).replace(/\+\//g, "-*")
    return `https://applinks.mvoicer.com/wsm/${path}?wsmtypespecial=1&content=${contents}`
  }
  return `https://applinks.mvoicer.com/wsm/${path}?wsmtypespecial=1`
}

export default {
  wsmOpenApp,
  appUrlAndroid,
  appUrlIOS
}


























 //eg:"mvoicerwsm://open.mvoicer.com/300001?wsmtypespecial=1&content=wsprn=$(this.privateroom)&wsrn=1002"

// v1let Base64 = require('js-base64').Base64;
//  export function wsmOpenApp(path,content){
//    if(content){
//      let contents=Base64.encode(content).replace(/\+\//g,"-*")
//      return `mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1&content=${contents}`
//    }
//   return `mvoicerwsm://open.mvoicer.com/${path}?wsmtypespecial=1`
//  }




 // export function wsmOpenApp(path,content){
 //   if(content){
 //        let contents= window.btoa(content).replace(/\+\//g,"-*")
 //        return `mvoicerwsm://open.mvoicer.com/${path}?wsmTypespecil=1&content=${contents}`
 //     }
 //    return `mvoicerwsm://open.mvoicer.com/${path}?wsmTypespecil=1`
 //  }


// WEBPACK FOOTER //
// ./src/assets/js/base64.js